/** @format */
'use client';
import React, { ReactNode } from 'react';
import styles from './UserIcon.module.css';

interface UserIconProps {
  // onClick: MouseEventHandler<HTMLDivElement>;

  children: ReactNode;
}

const UserIcon = React.forwardRef<HTMLDivElement, UserIconProps>((props, ref) => {
  return (
    <div className={styles.icon} id="user-icon" ref={ref} {...props}>
      {props.children}
    </div>
  );
});

UserIcon.displayName = 'UserIcon';

export default UserIcon;
